module.exports = __webpack_public_path__ + "img/batterry-full.d16f9a5a.svg";